import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../shared/FormStyles';

const Navbar = ({
  navName,
  showButtons,
  navbarRedirect,
  copyAllTiles,
  copyText,
  showCopyAudience,
}) => {
  const { t } = useTranslation('shared');
  return (
    <Nav>
      <Tab>{navName}</Tab>
      {showButtons && (
        <ButtonWrapper>
          <Button variant="tertiary" onClick={navbarRedirect}>
            {t('back')}
          </Button>
          {showCopyAudience && (
            <Button variant="containedBlue" onClick={copyAllTiles}>
              {copyText}
            </Button>
          )}
        </ButtonWrapper>
      )}
    </Nav>
  );
};

export default Navbar;

const Nav = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px;
  width: 100%;
`;

const Tab = styled.div`
  color: ${themeGet('colors.primary.100')};
  border-bottom: solid 2px ${themeGet('colors.primary.100')};
  padding: 8px 10px 15px;
  font-size: 14px;
  height: 42px;
  font-weight: 500;
`;

const ButtonWrapper = styled.div`
  width: 260px;
  display: flex;
  justify-content: end;
  gap: 8px;
`;
